import Srcset from '@/components/common/Srcset';
import React, { useEffect, useRef, useState } from 'react';
import { handleize } from "@/helpers/userHelpers";
import {
  Highlight,
} from "react-instantsearch-dom";
import {  slideToggle} from "@/helpers/userHelpers";
const FilterNavWrapper = (props) => {
  const { searchable, items, isFromSearch, searchForItems, level,nav_cat,
    nav_type,
    nav_subcat,itemArray,handleInputClick,styles,lableFilter,classActive,filterType,type,category,subcategory,filterParam } = props;
  const [appliedFilterCount, setAppliedFilterCount] = useState();
  const ulRef = useRef(null);
  useEffect(() => {
    setAppliedFilterCount(0);
    filterCountFun();
    setTimeout(() => {
      filterCountFun();
    }, 2000);
  });
  const filterCountFun = () => {
    if (!ulRef || !ulRef.current) {
      return
    }
    
    let count = '';
    let level = ulRef.current?.dataset?.level;
    let label_val = '';
    if(level === 'type') {
      label_val = ulRef.current.querySelector("input:checked")?.value;
      setAppliedFilterCount(label_val);
    } else {
      count = ulRef.current.querySelectorAll("input:checked").length;
      let str = '';
      if(count) {
        str = count > 1 ? count+' filters selected': '1 filter selected';
      }
      setAppliedFilterCount(str);
    }
  }
  let style_value='none';
  let collapse_class='collapse';
  
  if(filterType=='type') {
    style_value='none';
  } else if(filterType=='level') {
    style_value=type && !category && !subcategory ? 'block': 'none';
  } else if(filterType=='sublevel') {
    style_value = type && category ? 'block' : 'none';
    collapse_class='';
  }
  return (
    <>
    <div className={`${styles.filter_item} ${classActive} filter_item filter_nav_items filter_main_item ${collapse_class}`}>
        <div className={`${styles.filter_item_head}`} onClick={(e)=> {
          e.currentTarget.parentElement.classList.toggle('active')
          let nextElementSibling = e.currentTarget.nextElementSibling
          if(nextElementSibling.classList.contains('search_hide')){
            nextElementSibling = nextElementSibling.nextElementSibling
          } 
          slideToggle(nextElementSibling)
        }}>
          <div className={`${styles.filter_item_title} normal-sm normal-md small-xs`}>{lableFilter}</div>
          <div className={`${styles.filter_item_action}`}>
          {appliedFilterCount ? <span className={`${styles.filter_action_txt} x-small filter_count`}>
            {appliedFilterCount}</span> : null}
            <span className={`${styles.filter_action_plus}`}>
              <Srcset
                height="15"
                width="15"
                alt="Account"
                requirePath={true}
                svgFile={true}
                src={"images/Icons/Cross/Large.svg"}
              />
            </span>
          </div>
        </div>
    <div className={`${styles.filter_item_body} filter_body`} style={{display: `${style_value}`}}  >
  <ul className="filter_item_list" data-level={`${level}`} ref={ulRef}>
  {items.map((item,i) => (
      <li key={item.label}>

        <div className="custom-checkbox">
          {
            level === 'type'
            ? <input type='radio' name="type_filter" value={item.label} disabled={(nav_type) ? 'disabled' : ''} id={`${handleize(item.label)}_${i}`} checked={item.isRefined ? 'checked' : ''} onChange={e => {handleInputClick(e, [item.label], item.isRefined, itemArray[item.label]);filterCountFun();}}></input>
            : <input type='checkbox' disabled={(itemArray[item.label] === nav_cat || itemArray[item.label] === nav_subcat) ? 'disabled' : ''} id={`${handleize(item.label)}_${i}`} checked={item.isRefined ? 'checked' : ''} onChange={e => {handleInputClick(e, item.value, item.isRefined, itemArray[item.label]);filterCountFun();}}></input>
          }
          <label htmlFor={`${handleize(item.label)}_${i}`} className='small'>
            <span>
              {isFromSearch ? (
                <Highlight attribute="label" hit={item} />
              ) : (
                itemArray[item.label]
              )}
            </span>
          </label>
        </div>
      </li>
    ))}
  </ul>
  </div>
  </div>
  </>
  )
}

export default FilterNavWrapper;